import { Alert, Button, Dialog } from '@/ui'
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

export const RouteAccessDeniedDialog = ({ open }: { open: boolean }) => {
  const navigate = useNavigate()
  const goToDashboard = useCallback(() => {
    navigate('/dashboard')
  }, [navigate])
  const goToAccountSettings = useCallback(() => {
    navigate('/accounts')
  }, [navigate])
  return (
    <Dialog open={open}>
      <Dialog.Content>
        <Alert
          variant="warning"
          description="Your current subscription does not include access to this feature. You
            can upgrade your plan in your Account Settings."
        />

        <Dialog.Footer>
          <Dialog.Close asChild>
            <Button variant="primary" onClick={goToAccountSettings}>
              Go to Account Settings
            </Button>
          </Dialog.Close>
          <Dialog.Close asChild>
            <Button variant="secondary" onClick={goToDashboard}>
              Return to Dashboard
            </Button>
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
